export const SET_FLOWS = "SET_FLOWS";
